// import CognitoService from '@/services/CognitoService.js'

export const namespaced = true

export const state = {
	routeToPath: ''
}

export const mutations = {
	ADD_ROUTE_TO_PATH(state, { routeToPath }) {
		state.routeToPath = routeToPath
	}
}

export const actions = {
	addRouteToPath({ commit }, { routeToPath }) {
		commit('ADD_ROUTE_TO_PATH', { routeToPath })
	}
}

// export const state = {
// 	status: '',
// 	token: sessionStorage.getItem('token') || '',
// 	refreshToken: sessionStorage.getItem('refreshToken') || '',
// 	user: {},
// 	expireTime: ''
// }

// export const mutations = {
// 	AUTH_REQUEST(state) {
// 		state.status = 'loading'
// 	},
// 	AUTH_SUCCESS(state, { token, user, refreshToken, expireTime }) {
// 		state.status = 'success'
// 		state.token = token
// 		state.user = user
// 		state.refreshToken = refreshToken
// 		state.expireTime = expireTime
// 	},
// 	AUTH_ERROR(state) {
// 		state.status = 'error'
// 	},
// 	UPDATE_TOKEN(token, refreshToken) {
// 		state.token = token
// 		state.refreshToken = refreshToken
// 	},
// 	LOGOUT(state) {
// 		state.status = ''
// 		state.token = ''
// 	}
// }

// export const actions = {
// 	async login({ commit }, { username, password }) {
// 		try {
// 			console.log(username, password)
// 			const data = await CognitoService.login(username, password)
// 			const { token, user, refreshToken, expireTime } = data
// 			commit('AUTH_SUCCESS', {
// 				token,
// 				user,
// 				refreshToken,
// 				expireTime
// 			})
// 		} catch (e) {
// 			console.log(e)
// 		}
// 	},
// 	async renew({ commit }, { username, refreshToken }) {
// 		try {
// 			const data = await CognitoService.renew(username, refreshToken)
// 			const { newIdToken, newRefreshToken } = data
// 			commit('UPDATE_TOKEN', {
// 				newIdToken,
// 				newRefreshToken
// 			})
// 		} catch (e) {
// 			console.log(e)
// 		}
// 	}
// }
